
const title = "text-xl font-semibold py-1"
const subTitle = "text-md font-semibold py-1";

const containerOne = 'w-screen px-4 flex flex-col'
const containerTwo = 'w-screen h-screen flex flex-col px-6 py-8 justify-between'

const label = "text-sm py-1 font-semibold";
const valueStyle = "text-sm py-1";
const inputStyle = "rounded-xl px-4 py-3 outline-none border border-gray-500 bg-gray-100 w-full my-1" ;
const inputStyleTwo = "rounded-xl px-4 py-3 outline-none border-none bg-customTwo w-full my-1 text-sm" ;

const profileInputStyle = "rounded-xl px-4 py-3 outline-none border-none bg-customTwo w-full my-1 text-sm";

const btnOne = 'w-full border border-customOne rounded-lg py-2 px-6 text-center text-md text-white bg-customOne font-semibold'
const btnOneLight = 'flex items-center border border-customOne rounded-xl p-1 px-4 text-center text-sm text-white bg-customOne opacity-50 hover:opacity-70'
const btnTwo = 'w-full border border-customOne rounded-lg p-2 text-center text-customOne font-semibold'
const btnSmallTwo = 'border border-customOne rounded-lg py-2 px-6 text-center text-sm text-gray-200 bg-customOne flex gap-2 items-center'
const btnCancel = 'w-full border border-customThree rounded-lg p-2 px-6 text-center text-white bg-customThree font-semibold'
const btnSmall = 'border border-customOne rounded-full py-2 px-8 text-center text-white bg-customOne font-semibold flex gap-2 items-center'
const btnRound = 'bg-customTwo rounded-full p-3 cursor-pointer'
const btnWhite ='w-full rounded-lg p-2 bg-gray-100 text-sm flex items-center justify-center gap-2'

const tableHeader = 'text-sm py-1 font-semibold text-center'
const tableData = 'text-sm py-1 flex justify-center'

const errorText = 'text-xs py-1 font-semibold text-red-600'





export { 
    inputStyle, 
    inputStyleTwo,
    btnOne, 
    btnOneLight, 
    btnTwo, 
    btnSmall, 
    btnRound, 
    btnWhite, 
    btnSmallTwo, 
    btnCancel,
    title,
    subTitle,
    containerOne,
    containerTwo,
    label,
    valueStyle,
    tableHeader,
    tableData,
    errorText,
    profileInputStyle
};